export default __webpack_public_path__ + "static/media/ellipsis.ffe0745e.svg";